import {
    checkProjectUserAssignedAPI,
    getFeatureFlagsByProjectIdAPI,
    ProjectFeatureFlags,
    submitTimeTrackingDataAPI,
    TimeTrackingDataType,
    TimeTrackingResponseType,
    ProjectUserAssociationResponseType,
    getTimeSheetEntriesAPI,
    TimeSheetEntriesResponseType,
} from 'HTTPClients/projects.client.ts'
import { sanitizeAxiosError } from 'Utils/common.utils.ts'

export const getFeatureFlagsByProjectId = async (params: {
    projectId: string
    stepId?: string
}): Promise<ProjectFeatureFlags> => {
    const responseData = await getFeatureFlagsByProjectIdAPI(params.projectId, params.stepId)
    if (!responseData.isOk()) {
        throw sanitizeAxiosError(responseData.error) ?? 'Failed to get flags'
    }
    return responseData.value
}

export const submitTimeTrackingData = async (
    data: TimeTrackingDataType
): Promise<TimeTrackingResponseType> => {
    const responseData = await submitTimeTrackingDataAPI(data)
    if (!responseData.isOk()) {
        throw sanitizeAxiosError(responseData.error) ?? 'Failed to submit time tracking data'
    }
    return responseData.value
}

export const isUserAssociatedWithProject = async (params: {
    projectId: string
    userId: string
}): Promise<ProjectUserAssociationResponseType> => {
    const responseData = await checkProjectUserAssignedAPI(params.projectId, params.userId)
    if (!responseData.isOk()) {
        throw sanitizeAxiosError(responseData.error) ?? 'Failed to check project user assigned'
    }
    return responseData.value
}

export const projectTimeSheetEntries = async (params: {
    userId: string
    projectId: string
}): Promise<TimeSheetEntriesResponseType> => {
    const responseData = await getTimeSheetEntriesAPI(params.userId, params.projectId)
    if (!responseData.isOk()) {
        throw sanitizeAxiosError(responseData.error) ?? 'Failed to get timesheet entries'
    }
    return responseData.value
}
